import { Faculty } from '../types';

export enum FacultyActionType {
    GET_ALL_FACULTIES = 'GET_ALL_FACULTIES',
    GET_ALL_ADMIN_FACULTIES = 'GET_ALL_ADMIN_FACULTIES',
    GET_FACULTY = 'GET_FACULTY',
    CREATE_FACULTY = 'CREATE_FACULTY',
    UPDATE_FACULTY = 'UPDATE_FACULTY',
    DELETE_FACULTIES = 'DELETE_FACULTIES',
    MERGE_FACULTIES = 'MERGE_FACULTIES',
}

interface GetAllFacultiesAction {
    type: FacultyActionType.GET_ALL_FACULTIES;
    payload: Array<Faculty>;
}

interface GetAllAdminFacultiesAction {
    type: FacultyActionType.GET_ALL_ADMIN_FACULTIES;
    payload: Array<Faculty>;
}

interface GetFacultyAction {
    type: FacultyActionType.GET_FACULTY;
    payload: Faculty;
}

interface CreateFacultyAction {
    type: FacultyActionType.CREATE_FACULTY;
    payload: Faculty;
}

interface UpdateFacultyAction {
    type: FacultyActionType.UPDATE_FACULTY;
    payload: Faculty;
}

interface DeleteFacultiesAction {
    type: FacultyActionType.DELETE_FACULTIES;
    payload: Array<Faculty>;
}
interface MergeFacultiesAction {
    type: FacultyActionType.MERGE_FACULTIES;
    payload: Array<Faculty>;
}

export type FacultyAction =
    | GetAllFacultiesAction
    | GetAllAdminFacultiesAction
    | GetFacultyAction
    | CreateFacultyAction
    | UpdateFacultyAction
    | DeleteFacultiesAction
    | MergeFacultiesAction;
